import { get, map, mapValues } from 'lodash'
// eslint-disable-next-line import/no-cycle
import { deleteReq, getReq, postReq, putReq } from '../../utils/request'
import { CREATE_STORE_ITEMS, DELETE_STORE_ITEM, LOAD_SELECT_STORE_ITEMS, LOAD_STORE_ITEM, UPDATE_STORE_ITEMS } from './types'
import { IResetStore } from '../generalTypes'
// eslint-disable-next-line import/no-cycle
import { ThunkResult } from '../index'
// eslint-disable-next-line import/no-cycle
import { IUsersPayload } from '../usersU/actions'
import { IResponsePagination } from '../../types/interfaces'
import { formatDateWithTime } from '../../utils/helper'
// eslint-disable-next-line import/no-cycle
import { STORE_TYPE } from '../../pages/stores/Stores'

export type IStoreItemActions = IResetStore
	| IGetStoreItemsActions
	| IGetStoreItemAction

// storeItems
export interface IGetStoreItemsActions {
	type: LOAD_SELECT_STORE_ITEMS
	payload: IStoreItemsPayload
}

export interface IStoreItemsPayload {
	tableData: StoreItemTableItem[]
	originalData: StoreItemOriginalItem[]
	pagination: IResponsePagination | null
}

export type StoreItemTableItem = {
	key: number
	id: number
	count: number
	idealStockPercentage: number
	idealStockCount: number
	isCountOkeyCompareToIdealStock: number
	isInVirtualStore: boolean
	organizationName: string
	createdAt: string
	name: string
	updatedAt: string
}

export type StoreItemOriginalItem = {
	id: number
	createdAt: string
	name: string
	idealStockPercentage: number
	idealStockCount: number
	isCountOkeyCompareToIdealStock: number
	organizationName: string
	isInVirtualStore: boolean
	count: number
	updatedAt: string
}

export const getStoreItems = (
	page: number = 1,
	limit: number | null = 20,
	queryParams: any = {},
	onSuccess: (data: IStoreItemsPayload) => void = ((data) => {})
): ThunkResult<Promise<IStoreItemsPayload>> => async (dispatch) => {
	let payload = {} as IStoreItemsPayload
	try {
		dispatch({ type: LOAD_SELECT_STORE_ITEMS.START })

		const queries = {
			limit,
			page,
			...queryParams
		}

		const normalizeQueryParams = mapValues(queries, (query) => query || undefined)
		const { data } = await getReq('/api/admin/store-items', normalizeQueryParams)

		const originalData: StoreItemOriginalItem[] = get(data, 'storeItems', [])
		const tableData: StoreItemTableItem[] = map(originalData, (column) => ({
			key: column.id,
			id: column.id,
			name: column.name,
			idealStockPercentage: column.idealStockPercentage,
			idealStockCount: column.idealStockCount,
			isCountOkeyCompareToIdealStock: column.isCountOkeyCompareToIdealStock,
			organizationName: column.organizationName,
			count: column.count,
			isInVirtualStore: column.isInVirtualStore,
			createdAt: formatDateWithTime(column.createdAt),
			updatedAt: formatDateWithTime(column.updatedAt)
		}))

		payload = {
			tableData,
			originalData,
			pagination: get(data, 'context')
		}

		onSuccess(payload)
		dispatch({
			type: LOAD_SELECT_STORE_ITEMS.DONE,
			payload
		})
		return data
	} catch (error) {
		dispatch({ type: LOAD_SELECT_STORE_ITEMS.FAILED })
		Promise.reject(error)
		return error
	}
}

export interface IStoreItemForm {
	id: number | null
	name: string
	nameSlug: string
	isLiquid: boolean
	price: number | null
	isReplaceable: boolean
	idealStockPercentage: number
	activeJobs: number
	allAvailableStock: number
	updatedAt: string | null
	amountOfStockInAddresses: IStoreAddressItem[]
}

export interface IStoreAddressItem {
	id: number | null
	address: string
	userIdForEmployeeStoreType: string
	storeType: STORE_TYPE
	addressDeleted: boolean
	amountFrom: number
	amountTo: number
	amount: number
}

export const createStoreItems = (
	values: IStoreItemForm,
	onSuccess: (data: any) => void = ((data) => {
	}),
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFailure: (error: any) => void = ((error) => {
	})
): ThunkResult<Promise<IUsersPayload>> => async (dispatch) => {
	dispatch({
		type: CREATE_STORE_ITEMS.START
	})
	try {
		const normalizeQueryParams = mapValues(values, (query) => query || undefined)

		const { data } = await postReq('/api/admin/store-items', null, normalizeQueryParams)

		dispatch({ type: CREATE_STORE_ITEMS.DONE })

		onSuccess(get(data, 'data.id'))
		return get(data, 'data.id')
	} catch (error) {
		dispatch({ type: CREATE_STORE_ITEMS.FAILED })
		onFailure(error)
		return error
	}
}

export const updateStoreItem = (
	id: number,
	values: IStoreItemForm,
	onSuccess: () => void = (() => {
	}),
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFailure: (error: any) => void = ((error) => {
	})
): ThunkResult<Promise<boolean>> => async (dispatch) => {
	dispatch({
		type: UPDATE_STORE_ITEMS.START
	})
	try {
		await putReq(`/api/admin/store-items/${id}`, null, values)
		dispatch({ type: UPDATE_STORE_ITEMS.DONE })

		onSuccess()
		return true
	} catch (error) {
		dispatch({ type: UPDATE_STORE_ITEMS.FAILED })
		onFailure(error)
		return error
	}
}

// storeItem
interface IGetStoreItemAction {
	type: LOAD_STORE_ITEM
	payload: IStoreItemPayload
}

export interface IStoreItemPayload {
	data: IStoreItemDetail
}

export interface IStoreItemDetail {
	id: number
	name: string
	isLiquid: boolean
	price: number | null
	isReplaceable: boolean
	idealStockPercentage: number
	activeJobs: number
	nameSlug: string
	createdAt: string
	updatedAt: string
	allAvailableStock: number
	amountOfStockInAddresses: IStoreAddressItem[]
	organizationID: number
}

// noinspection JSUnusedLocalSymbols
export const getStoreItem = (
	id: number,
	onSuccess: (data: IStoreItemPayload) => void = ((data) => {}),
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFailure: (error: any) => void = ((error) => {
	})
): ThunkResult<Promise<IStoreItemPayload>> => async (dispatch) => {
	let payload = {} as IStoreItemPayload
	dispatch({
		type: LOAD_STORE_ITEM.START
	})
	try {
		const { data } = await getReq(`/api/admin/store-items/${id}`)

		payload = {
			data
		}

		dispatch({
			type: LOAD_STORE_ITEM.DONE,
			payload
		})

		onSuccess(payload)
		return payload
	} catch (error) {
		dispatch({
			type: LOAD_STORE_ITEM.FAILED
		})
		onFailure(error)
		return error
	}
}

export const deleteStoreItem = (
	id: number,
	onSuccess: () => void = (() => {
	}),
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	onFailure: (error: any) => void = ((error) => {
	})
): ThunkResult<Promise<boolean>> => async (dispatch) => {
	dispatch({ type: DELETE_STORE_ITEM.START })
	try {
		await deleteReq(`/api/admin/store-items/${id}`)

		dispatch({ type: DELETE_STORE_ITEM.DONE })
		onSuccess()
		return true
	} catch (error) {
		dispatch({ type: DELETE_STORE_ITEM.FAILED })
		onFailure(error)
		return false
	}
}
